export const testItems: (VideoMock | ImageMock | AudioMock | FileMock)[] = [
  {
    type: 'image',
    id: '2068b1_de4af4b7991f4650ac02c1c1a7f7715f~mv2.png',
    height: 1536,
    width: 1024,
  },
  {
    type: 'image',
    id: '2068b1_aa8c6d1b8c9f427eb67cf20764cf466a~mv2.png',
    height: 1536,
    width: 1024,
  },
  {
    type: 'image',
    id: '2068b1_7e7dcb8ffbdd4dfbbca63b52be0b633a~mv2.png',
    height: 1024,
    width: 1024,
  },
  {
    type: 'image',
    id: '2068b1_fc4c07bbce914b6b9658ee30f469cb5b~mv2.png',
    height: 1536,
    width: 1024,
  },
  {
    type: 'video',
    title: 'exapmle video 1',
    id: 'video/11062b_44ccd80751f749449aa3190c50d30535/1080p/mp4/file.mp4',
    thumbnail: {
      pathname: 'media/11062b_44ccd80751f749449aa3190c50d30535f000.jpg',
      width: 2560,
      height: 1440,
    },
  },
  {
    type: 'video',
    title: 'exapmle video 2',
    id: 'video/11062b_82db3f447bd042d1bac84a88e207ed28/1080p/mp4/file.mp4',
    thumbnail: {
      pathname: 'media/11062b_82db3f447bd042d1bac84a88e207ed28f000.jpg',
      width: 1920,
      height: 1080,
    },
  },
  {
    id: 'video/11062b_b8150d3b15684fc09fa4737d2b79261d/1080p/mp4/file.mp4',
    title: 'video 3',
    type: 'video',
    thumbnail: {
      pathname: 'media/11062b_b8150d3b15684fc09fa4737d2b79261df000.jpg',
      width: 2560,
      height: 1440,
    },
  },
  {
    type: 'audio',
    id: `mp3/f0f74f_35a1cdce4973490eac49e74c3244364d.mp3`,
    name: 'Dear Fear',
    authorName: 'KOTA The Friend',
  },
  {
    type: 'audio',
    id: `mp3/cd2f8a_5441102f2e064454bcf81979189079dc`,
    name: 'Sample Audio',
  },
  {
    type: 'file',
    name: 'image.jpg',
    id: 'image.jpg',
    url: 'https://static.wixstatic.com/media/feac6b9cf32640d3ac325c905f2b3786.jpg',
  },
  {
    type: 'file',
    name: 'document.pdf',
    id: 'document.pdf',
    url: 'https://cms.education.gov.il/NR/rdonlyres/BFBDB737-89E9-4B70-A1FF-1122B7AE8F1D/69371/14_HEB_ClassRecipeBook.pdf',
  },
  {
    type: 'file',
    name: 'music.mp3',
    id: 'music.mp3',
    url: 'https://static.wixstatic.com/mp3/f0f74f_43f712be42dc4377a075dcad3c358a80.mp3',
  },
];

type FileMock = {
  id: string;
  type: 'file';
  name: string;
  url: string;
};

type AudioMock = {
  type: 'audio';
  id: string;
  name: string;
  authorName?: string;
};
type VideoMock = {
  type: 'video';
  title: string;
  id: string;
  thumbnail: {
    pathname: string;
    width: number;
    height: number;
  };
};

type ImageMock = {
  type: 'image';
  id: string;
  width: number;
  height: number;
};
